import React from "react";
import styled from "styled-components";
import { FaUsers, FaMicrophoneAlt, FaRobot, FaBrain, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useState, useEffect, useRef } from "react";

/* ─────────────────────────────────────────
   IMAGE SLOTS — replace null with require()
   e.g. require("../assets/images/impact-showcase/panel4-a.webp")
───────────────────────────────────────── */
const panel4aImages = [
  require("../assets/images/summit/panel41.webp"),
  require("../assets/images/summit/panel42.webp"),
];
const panel4bImages = [
  require("../assets/images/summit/labtolaunch12.webp"),
  require("../assets/images/summit/labtolaunch11.webp"),
  require("../assets/images/summit/labtolaunch13.webp"),
];
const panel5Images  = [require("../assets/images/summit/SkillingfortheAIEconomy.webp")];
const panel6Images  = [require("../assets/images/summit/partnershowcase.webp")];
const expertAIImage = require("../assets/images/summit/bodhanai.webp");

/* ─────────────────────────────────────────
   DATA
───────────────────────────────────────── */
const topKeynote = {
  speaker: "Mr. Shivkumar Kalyanaraman",
  speakerRole: "CEO, ANRF",
  description:
    "Advancing India's research and innovation ecosystem through strategic funding, collaboration, and technology-driven growth.",
};

const panels = [
  {
    label: "Panel 4",
    number: "04",
    title: "Funding the Future: Corporate India's Role in Research Ecosystems",
    theme: "Research & Funding",
    description:
      "A discussion on how industry partnerships, philanthropy, and corporate investments can accelerate research, innovation, and translational impact in India.",
    membersLabel: "Panelist",
    members: [
      { name: "Mr. Vijaysankar", designation: "Chairman, Sanmar Group & Senior Vice President, FICCI" },
      { name: "Cmdr Puranik", designation: "Director – Corporate Planning & Personnel, Mazagon Dock Shipbuilders Ltd" },
      { name: "Dr. Venkatraman", designation: "Founder & CEO, Karkinos Healthcare" },
      { name: "Mr. Uday Prakash", designation: "Vice President – Market Strategy & Implementation, Herbalife International India Pvt. Ltd." },
    ],
    moderator: { name: "Prof. Manu Santhanam", designation: "Dean – Industrial Consultancy & Sponsored Research, IIT Madras" },
    images: panel4aImages,
    keynote: {
      speaker: "Mr. Shivkumar Kalyanaraman",
      speakerRole: "CEO, ANRF",
      description: "Advancing India's research and innovation ecosystem through strategic funding, collaboration, and technology-driven growth.",
    },
    twoColLayout: true,
  },
  {
    label: "Panel 5",
    number: "05",
    title: "Lab to Launch: Translational Tech Startups",
    theme: "Startups & Innovation",
    description:
      "A showcase featuring IIT Madras faculty-led startups translating cutting-edge research into impactful technologies and scalable entrepreneurial ventures across mobility, healthcare, analytics, and advanced engineering.",
    membersLabel: "Faculty & Startup Teams",
    members: [
      { name: "Prof. Satya Chakravarthi", designation: "Professor, Department of Aerospace Engineering, IIT Madras & Head, National Centre for Combustion Research & Development (NCCRD)" },
      { name: "Ms. Nithyashree", designation: "Chief of Staff, The ePlane Company" },
      { name: "Prof. Krishnan Balasubramaniam", designation: "Distinguished Institute Professor, Department of Mechanical Engineering & Head, Centre for Non-Destructive Evaluation (CNDE), IIT Madras" },
      { name: "Mr. Nishanth Raja", designation: "CEO & Co-Founder, XYMA Analytics" },
      { name: "Prof. Sujatha Srinivasan", designation: "Professor, Department of Mechanical Engineering & Head, TTK Center for Rehabilitation Research and Device Development (R2D2) and National Center for Assistive Health Technologies (NCAHT), IIT Madras" },
      { name: "Mr. Swostik Dash", designation: "CEO & Co-Founder, Neomotion" },
    ],
    moderator: { name: "Prof. Preeti Aghalayam", designation: "Dean – Global Engagement, IIT Madras" },
    images: panel4bImages,
    keynote: {
      speaker: "Prof. Nicolas Gascoin",
      speakerRole: "Deputy Counsellor for Cooperation and Cultural Affairs – Deputy Director of the French Institute in India (IFI), French Embassy in India, New Delhi",
      image: require("../assets/images/summit/labtolaunch13.webp"),
    },
    twoColLayout: true,
  },
  {
    label: "Panel 6",
    number: "06",
    title: "Skilling for the AI Economy: What Industry Needs from Academia",
    theme: "AI & Skills",
    description:
      "A discussion on aligning academia with industry requirements to build future-ready talent for the AI-driven economy, focusing on digital skills, innovation, workforce transformation, and emerging technologies.",
    membersLabel: "Panelist",
    members: [
      { name: "Ms. Preeti Lobana", designation: "Vice President & Country Manager, Google India" },
      { name: "Mr. Arun Karna", designation: "MD & CEO, AT&T Global Network Services India Pvt. Ltd." },
      { name: "Ms. Abhilasha Gaur", designation: "CEO, SSC NASSCOM" },
    ],
    moderator: { name: "Mr. Amandeep Singh Juneja", designation: "Country Lead – Enterprise Technology Services India, American Express India Private Limited" },
    images: panel5Images,
  },
  {
    label: "Panel 7",
    number: "07",
    title: "Reimagining CSR for India's Future — Partner Showcase",
    theme: "CSR & Societal Impact",
    description:
      "A discussion on the evolving role of Corporate Social Responsibility in driving sustainable development, inclusive growth, innovation, education, skilling, healthcare, and large-scale societal impact through industry-academia partnerships.",
    membersLabel: "Panelist",
    members: [
      { name: "Mr. Bibhuti Ranjan Pradhan", designation: "Executive Director (CD & CSR), Indian Oil Corporation Ltd." },
      { name: "Mr. Saurabh Sharma", designation: "Domain Head – Creating Shared Value, Hyundai Motor India Limited" },
      { name: "Mr. Anurag Prathap", designation: "Vice President & CSR Leader, Capgemini India" },
      { name: "Mr. Rathin Lahiri", designation: "Head – Marketing & CSR, SBI General Insurance Company Ltd." },
      { name: "Mr. Manjush Mathews", designation: "Head – Site Solutions & Engineering (Technology & Delivery), Indus Towers Ltd." },
    ],
    moderator: { name: "Mr. Kaviraj Nair", designation: "CEO – Office of Institutional Advancement, IIT Madras" },
    images: panel6Images,
  },
];

/* ─────────────────────────────────────────
   IMAGE SLOT COMPONENT
───────────────────────────────────────── */
const MiniCarousel = ({ images }) => {
  const [current, setCurrent] = useState(0);
  const timerRef = useRef(null);
  const total = images.length;

  const prev = () => setCurrent((c) => (c - 1 + total) % total);
  const next = () => setCurrent((c) => (c + 1) % total);

  useEffect(() => {
    if (total < 2) return;
    timerRef.current = setInterval(() => setCurrent((c) => (c + 1) % total), 3500);
    return () => clearInterval(timerRef.current);
  }, [total]);

  return (
    <MiniCarouselWrap>
      <MiniCarouselImg src={images[current]} alt={`Slide ${current + 1}`} />
      <MiniCarouselControls>
        <MiniCtrlBtn onClick={prev}><FaChevronLeft /></MiniCtrlBtn>
        <MiniDots>
          {images.map((_, i) => (
            <MiniDot key={i} active={i === current} onClick={() => setCurrent(i)} />
          ))}
        </MiniDots>
        <MiniCtrlBtn onClick={next}><FaChevronRight /></MiniCtrlBtn>
      </MiniCarouselControls>
    </MiniCarouselWrap>
  );
};

const ImgSlot = ({ src, alt }) =>
  src ? (
    <SlotImg src={src} alt={alt} />
  ) : (
    <SlotPlaceholder>
      <SlotLabel>Image coming soon</SlotLabel>
    </SlotPlaceholder>
  );

/* ─────────────────────────────────────────
   MAIN COMPONENT
───────────────────────────────────────── */
const ImpactShowcase = () => {
  return (
    <Section id="impact-showcase">
      <SectionLabel>Summit Highlights</SectionLabel>
      <MainHeading>Impact Showcase</MainHeading>
      <Divider />
      <SubHeading>
        A showcase highlighting transformative research, innovation-led societal impact, industry
        collaborations, and scalable solutions emerging from IIT Madras across healthcare,
        sustainability, technology, and entrepreneurship.
      </SubHeading>
      

      <Wrapper>

        {/* ── Panels ── */}
        {panels.map((panel, i) => (
          <React.Fragment key={i}>
          <PanelCard>

            <PanelHeader>
              {!panel.hideLabel && (
                <PanelNumber>
                  <PanelWord>{panel.label}</PanelWord>
                  {panel.number}
                </PanelNumber>
              )}
              <PanelMeta>
                <ThemeBadge>{panel.theme}</ThemeBadge>
                <PanelTitle>{panel.title}</PanelTitle>
                {panel.description && <PanelDesc>{panel.description}</PanelDesc>}
              </PanelMeta>
            </PanelHeader>

            {panel.twoColLayout ? (
              <ImpactTwoColBody>
                <ImpactTwoColLeft>
                  <ImpactTwoColInfo>
                    {panel.keynote && (
                      <KeynoteBox>
                        <KeynoteTag><FaMicrophoneAlt /> Keynote Address</KeynoteTag>
                        <KeynoteName>{panel.keynote.speaker}</KeynoteName>
                        {panel.keynote.speakerRole && <KeynoteRole>{panel.keynote.speakerRole}</KeynoteRole>}
                        {panel.keynote.description && <KeynoteDesc>{panel.keynote.description}</KeynoteDesc>}
                      </KeynoteBox>
                    )}
                  </ImpactTwoColInfo>
                  <ImpactSmallImageWrap>
                    <ImpactSmallImageCard>
                      <ImgSlot src={panel.keynote?.image || panel.images[0]} alt={`${panel.title} image 1`} />
                    </ImpactSmallImageCard>
                  </ImpactSmallImageWrap>
                </ImpactTwoColLeft>
                <ImpactTwoColRight>
                  <ImpactTwoColInfo>
                    <InfoBlock>
                      <InfoHeading><FaUsers /> {panel.membersLabel}</InfoHeading>
                      <MemberList>
                        {panel.members.map((m, j) => (
                          <MemberItem key={j}>
                            {typeof m === "object" ? (
                              <>
                                <span>{m.name}</span>
                                {m.designation && <ImpactMemberDesignation>{m.designation}</ImpactMemberDesignation>}
                              </>
                            ) : m}
                          </MemberItem>
                        ))}
                      </MemberList>
                    </InfoBlock>
                    <ModeratorBox>
                      <ModLabel>Moderator</ModLabel>
                      <ModName>{typeof panel.moderator === "object" ? panel.moderator.name : panel.moderator}</ModName>
                      {typeof panel.moderator === "object" && panel.moderator.designation && (
                        <ImpactMemberDesignation>{panel.moderator.designation}</ImpactMemberDesignation>
                      )}
                    </ModeratorBox>
                  </ImpactTwoColInfo>
                  <ImpactSmallImageWrap>
                    <ImpactSmallImageCard>
                      <ImgSlot src={panel.images[1]} alt={`${panel.title} image 2`} />
                    </ImpactSmallImageCard>
                  </ImpactSmallImageWrap>
                </ImpactTwoColRight>
              </ImpactTwoColBody>
            ) : panel.carouselLayout ? (
              <CarouselLayoutBody>
                <CarouselLayoutImages>
                  <MiniCarousel images={panel.images} />
                </CarouselLayoutImages>
                <CarouselLayoutInfo>
                  <InfoBlock>
                    <InfoHeading><FaUsers /> {panel.membersLabel}</InfoHeading>
                    <MemberList>
                      {panel.members.map((m, j) => (
                        <MemberItem key={j}>{m}</MemberItem>
                      ))}
                    </MemberList>
                  </InfoBlock>
                  <ModeratorBox>
                    <ModLabel>Moderator</ModLabel>
                    <ModName>{panel.moderator}</ModName>
                  </ModeratorBox>
                </CarouselLayoutInfo>
              </CarouselLayoutBody>
            ) : panel.tripleLayout ? (
              <TripleBody>
                <TripleInfo>
                  <InfoBlock>
                    <InfoHeading light><FaUsers /> {panel.membersLabel}</InfoHeading>
                    <MemberList>
                      {panel.members.map((m, j) => (
                        <MemberItem light key={j}>{m}</MemberItem>
                      ))}
                    </MemberList>
                  </InfoBlock>
                  <ModeratorBox dark>
                    <ModLabel light>Moderator</ModLabel>
                    <ModName light>{panel.moderator}</ModName>
                  </ModeratorBox>
                </TripleInfo>
                <TripleImages>
                  {panel.images[0] && (
                    <MainImg src={panel.images[0]} alt={`${panel.title} main`} />
                  )}
                  {panel.images[1] && (
                    <InsetImg src={panel.images[1]} alt={`${panel.title} inset`} />
                  )}
                </TripleImages>
              </TripleBody>
            ) : (
              <PanelBody>
                <PanelInfo>
                  <InfoBlock>
                    <InfoHeading><FaUsers /> {panel.membersLabel}</InfoHeading>
                    <MemberList>
                      {panel.members.map((m, j) => (
                        <MemberItem key={j}>
                          {typeof m === "object" ? (
                            <>
                              <span>{m.name}</span>
                              {m.designation && <ImpactMemberDesignation>{m.designation}</ImpactMemberDesignation>}
                            </>
                          ) : m}
                        </MemberItem>
                      ))}
                    </MemberList>
                  </InfoBlock>
                  <ModeratorBox>
                    <ModLabel>Moderator</ModLabel>
                    <ModName>{typeof panel.moderator === "object" ? panel.moderator.name : panel.moderator}</ModName>
                    {typeof panel.moderator === "object" && panel.moderator.designation && (
                      <ImpactMemberDesignation>{panel.moderator.designation}</ImpactMemberDesignation>
                    )}
                  </ModeratorBox>
                </PanelInfo>
                <PanelImages count={panel.images.length}>
                  {panel.images.map((src, j) => (
                    <ImgSlot key={j} src={src} alt={`${panel.title} image ${j + 1}`} />
                  ))}
                </PanelImages>
              </PanelBody>
            )}

          </PanelCard>

          {/* Insert Expert Talk on AI after Lab to Launch (index 1) */}
          {i === 1 && (
            <ExpertCard>
              <ExpertInfo>
                <ExpertTag>
                  <FaBrain /> Expert Talk on AI
                </ExpertTag>
                <ExpertName>Prof. Mitesh Khapra</ExpertName>
                <ExpertLinks>
                  <ExpertLink>Faculty, Department of Data Science and AI · IIT Madras</ExpertLink>
                  <ExpertLink href="https://bodhan.ai/" target="_blank" rel="noopener noreferrer" as="a">
                    Faculty PI / Head — AI4Bharat and Bodhan AI
                  </ExpertLink>
                </ExpertLinks>
              </ExpertInfo>
              <ExpertImageWrap>
                <ImgSlot src={expertAIImage} alt="Prof. Mitesh Khapra" />
              </ExpertImageWrap>
            </ExpertCard>
          )}
          </React.Fragment>
        ))}


      </Wrapper>
    </Section>
  );
};

export default ImpactShowcase;


/* ═══════════════════════════════════════
   STYLES
═══════════════════════════════════════ */

const Section = styled.section`
  padding: 20px 20px;
  background: #faf8f5;

  @media (max-width: 768px) {
    padding: 16px 14px;
  }
`;

const SectionLabel = styled.p`
  text-align: center;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #d6a54f;
  margin-bottom: 10px;
`;

const MainHeading = styled.h2`
  text-align: center;
  font-size: 38px;
  font-weight: 700;
  color: #791e1b;
  margin: 0 0 14px;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

const SubHeading = styled.p`
  text-align: center;
  max-width: 820px;
  margin: 0 auto 20px;
  font-size: 15px;
  line-height: 1.8;
  color: #4b5563;
`;

const Divider = styled.div`
  width: 60px;
  height: 4px;
  background: #d6a54f;
  border-radius: 2px;
  margin: 0 auto 22px;
`;

const Wrapper = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

/* ── Top Keynote ── */

const TopKeynoteCard = styled.div`
  background: #171f32;
  border-radius: 18px;
  padding: 36px 40px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: 768px) {
    padding: 24px 20px;
  }
`;

const KeynoteTag = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #d6a54f;
`;

const KeynoteSpeaker = styled.h3`
  font-size: 26px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const KeynoteSpeakerRole = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #d6a54f;
`;

const KeynoteDesc = styled.p`
  font-size: 15px;
  color: #9ca3af;
  line-height: 1.7;
  margin: 0;
  max-width: 700px;
`;

/* ── Triple layout ── */

const TripleBody = styled.div`
  display: grid;
  grid-template-columns: 340px 1fr;
  min-height: 360px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const TripleInfo = styled.div`
  background: #171f32;
  padding: 32px 28px;
  display: flex;
  flex-direction: column;
  gap: 28px;
  justify-content: center;
`;

const TripleImages = styled.div`
  position: relative;
  overflow: hidden;
  min-height: 360px;
`;

const MainImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

const InsetImg = styled.img`
  position: absolute;
  top: 16px;
  left: 16px;
  width: 200px;
  height: 140px;
  object-fit: cover;
  border-radius: 10px;
  border: 3px solid #fff;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: zoom-in;

  &:hover {
    transform: scale(1.5);
    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.5);
    z-index: 10;
  }

  @media (max-width: 640px) {
    width: 130px;
    height: 90px;
  }
`;

/* ── Panel card ── */

const PanelCard = styled.div`
  background: #ffffff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 22px rgba(0, 0, 0, 0.07);
  border: 1px solid #f0ebe3;
`;

const PanelHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding: 28px 32px 20px;
  border-bottom: 1px solid #ede8e0;
  background: #faf8f5;

  @media (max-width: 768px) {
    padding: 20px 18px 16px;
    gap: 14px;
  }
`;

const PanelNumber = styled.span`
  font-size: 52px;
  font-weight: 900;
  color: #ede0cc;
  line-height: 1;
  flex-shrink: 0;
  margin-top: -4px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    font-size: 34px;
  }
`;

const PanelWord = styled.span`
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #c4a882;
  line-height: 1;
  margin-bottom: 2px;
`;

const PanelMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const ThemeBadge = styled.span`
  display: inline-block;
  background: #f9e8e8;
  color: #791e1b;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  padding: 3px 12px;
  border-radius: 20px;
  align-self: flex-start;
`;

const PanelTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: #171f32;
  margin: 0;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const PanelDesc = styled.p`
  font-size: 14px;
  color: #6b7280;
  line-height: 1.7;
  margin: 0;
`;

const PanelBody = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const PanelInfo = styled.div`
  padding: 24px 32px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  border-right: 1px solid #ede8e0;

  @media (max-width: 768px) {
    padding: 20px 18px;
    border-right: none;
    border-bottom: 1px solid #ede8e0;
  }
`;

const InfoBlock = styled.div``;

const InfoHeading = styled.p`
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: ${(p) => (p.light ? "#d6a54f" : "#791e1b")};
  margin-bottom: 12px;
`;

const MemberList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const MemberItem = styled.li`
  font-size: 15px;
  font-weight: 600;
  color: ${(p) => (p.light ? "#e5e7eb" : "#171f32")};
  padding-left: 14px;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #d6a54f;
  }
`;

const ModeratorBox = styled.div`
  background: ${(p) => (p.dark ? "rgba(255,255,255,0.06)" : "#faf8f5")};
  border-radius: 10px;
  padding: 14px 18px;
  border-left: 3px solid ${(p) => (p.dark ? "#d6a54f" : "#791e1b")};
`;

const ModLabel = styled.p`
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: ${(p) => (p.light ? "#d6a54f" : "#791e1b")};
  margin-bottom: 4px;
`;

const ModName = styled.p`
  font-size: 15px;
  font-weight: 700;
  color: ${(p) => (p.light ? "#ffffff" : "#171f32")};
  margin: 0;
`;

const PanelImages = styled.div`
  display: grid;
  grid-template-rows: ${(p) => (p.count === 2 ? "1fr 1fr" : "1fr")};
  min-height: 280px;
`;

const SlotImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

const SlotPlaceholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: repeating-linear-gradient(
    135deg,
    #f5f0e8 0px,
    #f5f0e8 18px,
    #ede8e0 18px,
    #ede8e0 36px
  );
  min-height: 120px;
`;

const SlotLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #b09060;
  letter-spacing: 1px;
  background: rgba(255, 255, 255, 0.7);
  padding: 6px 14px;
  border-radius: 20px;
`;

/* ── Expert Talk on AI ── */

const ExpertCard = styled.div`
  background: #171f32;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 22px rgba(0, 0, 0, 0.13);
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ExpertInfo = styled.div`
  padding: 36px 40px 28px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: 768px) {
    padding: 24px 20px 20px;
  }
`;

const ExpertTag = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #d6a54f;
`;

const ExpertName = styled.h3`
  font-size: 26px;
  font-weight: 700;
  color: #fff;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const ExpertRole = styled.p`
  font-size: 14px;
  color: #9ca3af;
  line-height: 1.6;
  margin: 0;
`;

const ExpertLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
`;

const ExpertLink = styled.span`
  background: rgba(214, 165, 79, 0.15);
  border: 1px solid rgba(214, 165, 79, 0.4);
  color: #d6a54f;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 14px;
  border-radius: 20px;
  text-decoration: none;
`;

const ExpertImageWrap = styled.div`
  min-height: 260px;

  ${SlotImg} {
    height: 100%;
  }

  ${SlotPlaceholder} {
    height: 100%;
    background: repeating-linear-gradient(
      135deg,
      #1e2740 0px,
      #1e2740 18px,
      #171f32 18px,
      #171f32 36px
    );

    ${SlotLabel} {
      color: #d6a54f;
      background: rgba(0, 0, 0, 0.4);
    }
  }
`;

/* ── Carousel layout ── */

/* ── Two-col layout (Panel 4) ── */

const ImpactTwoColBody = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ImpactTwoColLeft = styled.div`
  display: flex;
  flex-direction: column;
  border-right: 1px solid #ede8e0;

  @media (max-width: 768px) {
    border-right: none;
    border-bottom: 1px solid #ede8e0;
  }
`;

const ImpactTwoColRight = styled.div`
  display: flex;
  flex-direction: column;
`;

const ImpactTwoColInfo = styled.div`
  padding: 28px 32px 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 768px) {
    padding: 20px 18px;
  }
`;

const ImpactSmallImageWrap = styled.div`
  padding: 0 32px 24px;

  @media (max-width: 768px) {
    padding: 0 18px 20px;
  }
`;

const ImpactSmallImageCard = styled.div`
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: 1px solid #ede8e0;

  img {
    width: 100%;
    height: auto;
    object-fit: contain;
    display: block;
  }
`;

const ImpactMemberDesignation = styled.span`
  display: block;
  font-size: 12px;
  font-weight: 400;
  color: #6b7280;
  line-height: 1.4;
  margin-top: 2px;
`;

const KeynoteBox = styled.div`
  background: #171f32;
  border-radius: 12px;
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const KeynoteName = styled.span`
  font-size: 17px;
  font-weight: 700;
  color: #fff;
`;

const KeynoteRole = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #d6a54f;
`;

const CarouselLayoutBody = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: 370px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const CarouselLayoutInfo = styled.div`
  padding: 28px 32px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  border-left: 1px solid #ede8e0;

  @media (max-width: 768px) {
    padding: 20px 18px;
    border-left: none;
    border-top: 1px solid #ede8e0;
  }
`;

const CarouselLayoutImages = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

/* ── Mini carousel ── */

const MiniCarouselWrap = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background: #171f32;
`;

const MiniCarouselImg = styled.img`
  width: 100%;
  height: 320px;
  object-fit: cover;
  display: block;
`;

const MiniCarouselControls = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 10px 16px;
  background: #171f32;
`;

const MiniCtrlBtn = styled.button`
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.35);
  color: #ffffff;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.25);
  }
`;

const MiniDots = styled.div`
  display: flex;
  gap: 6px;
`;

const MiniDot = styled.button`
  width: ${(p) => (p.active ? "20px" : "8px")};
  height: 8px;
  border-radius: 4px;
  border: none;
  background: ${(p) => (p.active ? "#ffffff" : "rgba(255,255,255,0.3)")};
  cursor: pointer;
  transition: width 0.3s ease, background 0.3s ease;
  padding: 0;
`;
